import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth.store';
import type { UserRole } from '../../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { accessToken, user, mustChangePassword, mustEnrollTotp } = useAuthStore();

  if (!accessToken || !user) {
    return <Navigate to="/login" replace />;
  }

  // Admin accounts gated by a forced password change / 2FA enrollment can't use the app yet.
  const isAdmin = user.role === 'platform_admin' || user.role === 'admin';
  if (isAdmin && (mustChangePassword || mustEnrollTotp)) {
    return <Navigate to="/security-setup" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    const fallbackPath = user.role === 'partner_dev' ? '/apps' : '/dashboard';
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};
